import React from 'react';

import {components, OptionProps} from 'react-select';
import styled from 'styled-components';

import {colors, font} from 'theme';

export const Wrapper = styled.div`
    display: flex;
    gap: 4px;
`;

const Separator = styled.span`
    display: inline-flex;
    width: auto;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
`;
const Label = styled.div<{isSelected?: boolean}>`
    display: inline-flex;
    width: auto;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey1)};
    margin-bottom: 4px;
`;
const Code = styled.div<{isSelected?: boolean}>`
    display: inline-flex;
    width: auto;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey2)};
`;

export const CustomerSelectOption = (props: OptionProps<any, false>) => {
    const {data} = props;
    const itemData: {
        number: string;
        value: number;
        label: string;
    } = {...data};
    return (
        <components.Option {...props}>
            <Wrapper>
                <Label isSelected={props.isSelected}>{itemData.label}</Label>
                <Separator>-</Separator>
                <Code isSelected={props.isSelected}>{itemData.number}</Code>
            </Wrapper>
        </components.Option>
    );
};
